import { forwardRef } from "react";
import { useCompany } from "../contexts/CompanyContext";

const fmtDate = (s) => {
    if (!s) return "—";
    const parts = s.split("-");
    if (parts.length !== 3) return s;
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

export const BadgePreview = forwardRef(({ employee, size = "std" }, ref) => {
    const company = useCompany();
    const fullName = `${(employee?.cognome || "COGNOME").toUpperCase()} ${(employee?.nome || "NOME").toUpperCase()}`;
    const hasClienteLogo = !!employee?.cliente_logo;
    const qualificaEvidenza = !!employee?.qualifica_evidenza;
    const qualificaValue = employee?.qualifica || "—";
    return (
        <div ref={ref} className={`badge-card${size === "xl" ? " badge-card--xl" : ""}`} data-testid="badge-preview">
            <div className="badge-top-banner">
                <div className="badge-top-slot left" />
                <div className="badge-top-slot center">
                    <img
                        src="/brand/logo-full.jpg"
                        alt={company.ragione_sociale}
                        className="badge-main-logo"
                    />
                </div>
                <div className="badge-top-slot right" />
            </div>

            <div className="badge-body">
                <div className="badge-left">
                    <div className="badge-employee-name" data-testid="badge-name">{fullName}</div>

                    <div className="badge-field">
                        <span className="lbl">Data di Nascita: </span>
                        <span>{fmtDate(employee?.data_nascita)}</span>
                    </div>

                    <div className="badge-field">
                        <span className="lbl">Qualifica: </span>
                        {qualificaEvidenza ? (
                            <span
                                className="badge-qualifica-rossa"
                                data-testid="badge-qualifica-evidenza"
                            >
                                {qualificaValue.toUpperCase()}
                            </span>
                        ) : (
                            <span>{qualificaValue}</span>
                        )}
                    </div>

                    <div className="badge-field">
                        <span className="lbl">Data di Assunzione: </span>
                        <span>{fmtDate(employee?.data_assunzione)}</span>
                    </div>
                    <div className="badge-field">
                        <span className="lbl">Pos. INAIL TA: </span>
                        <span>{employee?.pos_inail || "—"}</span>
                    </div>
                    <div className="badge-field">
                        <span className="lbl">Pos. INPS TA: </span>
                        <span>{employee?.pos_inps || "—"}</span>
                    </div>

                    <div className="badge-company">
                        <div className="badge-company-name">{company.ragione_sociale}</div>
                        <div className="badge-company-tag">{company.tagline}</div>
                        <div className="badge-field">
                            <span className="lbl">Sede: </span>
                            <span>{company.sede}</span>
                        </div>
                        <div className="badge-field">
                            <span className="lbl">P.IVA: </span>
                            <span>{company.p_iva}</span>
                        </div>
                    </div>
                </div>

                <div className="badge-right">
                    {employee?.photo ? (
                        <img
                            className="badge-photo"
                            src={employee.photo}
                            alt="Foto dipendente"
                            data-testid="badge-photo"
                        />
                    ) : (
                        <div className="badge-photo-placeholder">FOTO<br />DIPENDENTE</div>
                    )}
                    {employee?.matricola && (
                        <div className="badge-mat-circle" data-testid="badge-matricola">
                            Matr. N° {employee.matricola}
                        </div>
                    )}
                    {hasClienteLogo && (
                        <div className="badge-cliente-wrap" data-testid="badge-cliente-logo">
                            <img
                                src={employee.cliente_logo}
                                alt="Logo cliente"
                                className="badge-cliente-logo"
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className="badge-footer-bar" />
        </div>
    );
});

BadgePreview.displayName = "BadgePreview";
